import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmt } from "@/api";
import { useApp } from "@/context/AppContext";
import { Sparkles, Users, Package } from "lucide-react";

export default function Kits() {
  const [kits, setKits] = useState([]);
  const { addToCart } = useApp();
  useEffect(() => { api.get("/kits").then(({data}) => setKits(data)); }, []);

  const addKit = (k) => {
    k.items.forEach(i => addToCart({product_id:`kit-${k.id}-${i.name}`, name:i.name, price:i.price, image:i.image, kit:true}, i.qty));
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="section-label">Puja Kits</div>
      <h1 className="font-serif text-4xl md:text-5xl mt-2">Ready-made Puja Kits, curated with care</h1>
      <p className="mt-3 text-muted-foreground max-w-2xl">Each kit is thoughtfully assembled by our expert team. No missing items, no last-minute panic. Choose Simple, Complete, or Premium.</p>
      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {kits.map(k => {
          const disc = k.mrp > k.price ? Math.round(((k.mrp-k.price)/k.mrp)*100) : 0;
          return (
            <div key={k.id} className="pk-card flex flex-col" data-testid={`kit-card-${k.slug}`}>
              <Link to={`/kit/${k.slug}`} className="relative aspect-[4/3] block bg-muted overflow-hidden">
                <img src={k.image} alt={k.name} className="w-full h-full object-cover"/>
                {disc>0 && <span className="absolute top-3 left-3 bg-accent text-white text-xs font-bold px-2 py-1 rounded-full">Save {disc}%</span>}
                <span className="absolute top-3 right-3 bg-primary text-white text-[10px] uppercase tracking-widest px-2 py-1 rounded-full">{k.kit_type}</span>
              </Link>
              <div className="p-5 flex-1 flex flex-col">
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{k.puja} · {k.occasion}</div>
                <h3 className="font-serif text-xl mt-1">{k.name}</h3>
                <div className="mt-2 flex items-center gap-4 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5"/>{k.serves || k.family_size}</span>
                  <span className="flex items-center gap-1"><Package className="w-3.5 h-3.5"/>{k.items.length} items</span>
                </div>
                <div className="mt-3 flex items-baseline gap-2">
                  <span className="text-2xl font-semibold text-primary">{fmt(k.price)}</span>
                  {k.mrp > k.price && <span className="line-through text-muted-foreground text-sm">{fmt(k.mrp)}</span>}
                </div>
                <div className="mt-4 flex gap-2">
                  <Link to={`/kit/${k.slug}`} className="flex-1 py-2 rounded-full border border-primary text-primary text-sm font-medium text-center hover:bg-primary hover:text-white transition-colors">View Kit</Link>
                  <button data-testid={`add-kit-${k.slug}`} onClick={()=>addKit(k)} className="flex-1 py-2 rounded-full bg-primary text-white text-sm font-medium hover:bg-[#a11919]">Add to Cart</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
